var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100"},[_c('sf-card',{staticClass:"w-100 h-100"},[_c('bar-chart',{ref:"grpBar",attrs:{"height":180,"chartData":_vm.datacollection,"options":_vm.options}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }